import styled from 'styled-components';

import { ModalHeading } from 'components/modal';

export const StyledModalHeader = styled(ModalHeading)`
  margin: 1rem auto;
  font-size: 1.85rem;
  max-width: 100%;
  white-space: initial;
`;

export const StyledAddressTitle = styled.p`
  font-size: 1.0625rem;
  flex-grow: 1;
  font-weight: 900;
  margin: 0;
`;

export const StyledAddressDescription = styled.p`
  font-size: 0.875rem;
  font-weight: 400;
  flex-grow: 1;
  margin: 0;
`;
